
import React, { useState } from "react";
import styles from "./styles_plants.module.css";

interface PlantsData {
  key: number;
  region: string;
  counts: Record<string, string>;
}

const regions = [
  "Чуйская",
  "Ошская",
  "Нарынская",
  "Баткенская",
  "Таласская",
  "Иссык-Кульская",
  "Джалал-Абадская",
] as const;

const plants = ["Зерно", "Пшеница", "Ячмень", "Кукуруза","Рис", "Зернобобовые", "Сахарная свекла", "Хлопок-сырец", "Табак", "Масличные культуры","Картофель", "Овощи", "Бахчи продовольственные", "Плоды и ягоды", "Виноград"] as const;

const dataSource: PlantsData[] = [
  {
    key: 0,
    region: "Чуйская",
    counts: {
      'Зерно': '627',
      'Пшеница': '161',
      'Ячмень': '178',
      'Кукуруза': '287',
      'Рис': '-',
      'Зернобобовые': '0.8',
      'Сахарная свекла': '582',
      'Хлопок-сырец': '0.1',
      'Табак': '0.3',
      'Масличные культуры': '5.8',
      'Картофель': '171.2',
      'Овощи': '456.2',
      'Бахчи продовольственные': '88.2',
      'Плоды и ягоды': '20.7',
      'Виноград': '1.3',
    },
  },
  {
    key: 1,
    region: "Баткенская",
    counts: {
        'Зерно': '97.7',
        'Пшеница': '24.4',
        'Ячмень': '11.4',
        'Кукуруза': '61.9',
        'Рис': '13.3',
        'Зернобобовые': '1.8',
        'Сахарная свекла': '-',
        'Хлопок-сырец': '-',
        'Табак': '0.1',
        'Масличные культуры': '0.8',
        'Картофель': '37.2',
        'Овощи': '63.8',
        'Бахчи продовольственные': '1.4',
        'Плоды и ягоды': '60.6',
        'Виноград': '1.9',
    },
  },
  {
    key: 2,
    region: "Джалал Абадская",
    counts: {
        'Зерно': '280.8',
        'Пшеница': '47',
        'Ячмень': '24.1',
        'Кукуруза': '209.1',
        'Рис': '20.6',
        'Зернобобовые': '0.3',
        'Сахарная свекла': '-',
        'Хлопок-сырец': '34.1',
        'Табак': '-',
        'Масличные культуры': '5.5',
        'Картофель': '127.4',
        'Овощи': '327.1',
        'Бахчи продовольственные': '94.3',
        'Плоды и ягоды': '72.8',
        'Виноград': '-',
    },
  },
  {
    key: 3,
    region: "Нарынская ",
    counts: {
        'Зерно': '47.7',
        'Пшеница': '12.4',
        'Ячмень': '35.1',
        'Кукуруза': '0.1',
        'Рис': '-',
        'Зернобобовые': '-',
        'Сахарная свекла': '-',
        'Хлопок-сырец': '-',
        'Табак': '-',
        'Масличные культуры': '-',
        'Картофель': '95.7',
        'Овощи': '5.8',
        'Бахчи продовольственные': '-',
        'Плоды и ягоды': '0.5',
        'Виноград': '-',
    },
  },
  {
    key: 4,
    region: "Ошская ",
    counts: {
        'Зерно': '333.4',
        'Пшеница': '82.2',
        'Ячмень': '38.3',
        'Кукуруза': '212.8',
        'Рис': '12.8',
        'Зернобобовые': '-',
        'Сахарная свекла': '-',
        'Хлопок-сырец': '29.3',
        'Табак': '1',
        'Масличные культуры': '2.1',
        'Картофель': '211.3',
        'Овощи': '198.2',
        'Бахчи продовольственные': '49.4',
        'Плоды и ягоды': '59.6',
        'Виноград': '0.7',
    },
  },
  {
    key: 5,
    region: "Таласская",
    counts: {
        'Зерно': '52.3',
        'Пшеница': '22.2',
        'Ячмень': '6.5',
        'Кукуруза': '23.6',
        'Рис': '-',
        'Зернобобовые': '68.9',
        'Сахарная свекла': '37.6',
        'Хлопок-сырец': '-',
        'Табак': '-',
        'Масличные культуры': '0.8',
        'Картофель': '181.1',
        'Овощи': '96.5',
        'Бахчи продовольственные': '2.4',
        'Плоды и ягоды': '21',
        'Виноград': '-',
    },
  },
  {
    key: 6,
    region: "Иссык-Кульская",
    counts: {
        'Зерно': '178.2',
        'Пшеница': '90.3',
        'Ячмень': '87.1',
        'Кукуруза': '-',
        'Рис': '-',
        'Зернобобовые': '0.4',
        'Сахарная свекла': '0.5',
        'Хлопок-сырец': '-',
        'Табак': '-',
        'Масличные культуры': '-',
        'Картофель': '460.7',
        'Овощи': '56.3',
        'Бахчи продовольственные': '-',
        'Плоды и ягоды': '72.8',
        'Виноград': '-',
    },
  },

];

export const ProductionPlants: React.FC = () => {
  const [selectedPlants, setSelectedPlants] = useState<typeof plants[number]>(
    plants[0]
  );

  const handlePlantsChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedPlants(event.target.value as typeof plants[number]);
  };

  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        <h2>Данные по областям (тонн)</h2>
        <select
          value={selectedPlants}
          onChange={handlePlantsChange}
          className={styles.select}
        >
          {plants.map((plant) => (
            <option key={plant} value={plant}>
              {plant}
            </option>
          ))}
        </select>

        <ul className={styles.table}>
          <li className={styles.header}>
            <span className={styles.cell}>Область</span>
            <span className={styles.cell}>{selectedPlants}</span>
          </li>
          {dataSource.map((item) => (
            <li key={item.key} className={styles.row}>
              <span className={styles.cell}>{item.region}</span>
              <span className={styles.cell}>
                {item.counts[selectedPlants] || 'Нет данных'}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

